import { cn } from "@/utils/cn";
import { Color } from "@ionic/core";
import { IonButton } from "@ionic/react";
interface OutlinedButtonProps {
  text?: string;
  children?: React.ReactNode;
  size?: "small" | "default" | "large";
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  disabled?: boolean;
  color?: (Color & string) | undefined;
}

export const OutlinedButton = ({
  text,
  children,
  size = "small",
  className,
  style,
  color = "dark",
  disabled,
  onClick,
}: OutlinedButtonProps) => {
  return (
    <IonButton
      className={cn("flex-1 border rounded-lg border-gray-200", className)}
      size={size}
      fill="clear"
      color={color}
      onClick={onClick}
      style={{
        textTransform: "none",
        fontWeight: "600",
        ...style,
      }}
      disabled={disabled}
    >
      {children || text}
    </IonButton>
  );
};
